import * as React from 'react';
// import styles from './index.less';

interface FApplyProps {
    className?: string;
    style?: React.CSSProperties;

    onClick?(): void;
}

function FApply({className, ...props}: FApplyProps) {
    return (<i className={['freelog', 'fl-icon-yingyongyuquanbu', className].join(' ')} {...props} />);
}

export default FApply;
